import { render, staticRenderFns } from "./MatchupBracketDesktop.vue?vue&type=template&id=2f9220ca&scoped=true&"
import script from "./MatchupBracketDesktop.vue?vue&type=script&lang=js&"
export * from "./MatchupBracketDesktop.vue?vue&type=script&lang=js&"
import style0 from "./MatchupBracketDesktop.vue?vue&type=style&index=0&id=2f9220ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9220ca",
  null
  
)

export default component.exports